<div class="flex-column">
    @if(screenCalling == 'ADMISSIONS'){
        <span class="headline-1 mbs-5 text-primary-darker-title">
            {{ ('modules.admissions.admissions-provisions.template-title-arrangement' | exp:'':'Convenio')  }}
        </span>
        <div>
            <app-theme-card themeScope="admissions">
                <form [formGroup]="arrangementForm">
                    <div class="flex-column flex-30 p-1">
                        <span class="subtitle-3 text-primary-darker mbs-1">
                            {{ 'modules.admissions.admissions-provisions.template-title-arrangement' | exp:'':'Convenio' }}
                        </span>
                        <app-select-searching-input (selected)="this.onSelectArrangement($event)" [name]="this.ARRANGEMENT"
                        [nameSearching]="this.ARRANGEMENT_SEARCHING" [form]="this.arrangementForm"
                        [placeholder]="('modules.admissions.admissions-provisions.arrangement-form.placeholders.select-arrangement' | exp:'':'Seleccionar convenio')"
                        [elements]="this.activeArrangements" [calculateId]="this.calculateIdArrangement" [calculateName]="this.calculateNameArrangement"
                        [placeholderNoValue]="('modules.admissions.admissions-provisions.arrangement-form.placeholders.no-value' | exp:'':'Sin resultados')" [placeholderSearching]="('modules.admissions.admissions-provisions.arrangement-form.placeholders.searching' | exp:'':'Buscar convenio...')"
                        [noOptionText]="('modules.admissions.admissions-provisions.arrangement-form.placeholders.no-option' | exp:'':'Sin convenio')">
                    </app-select-searching-input>
                </div>
            </form>
        </app-theme-card>
    </div>
}

<app-admissions-modules [financierId]="financierIdSelected" (modulesData)="getCaseModulesData($event)"
    [modulesArrangement]="arrangementSelected?.moduleArrangements" (formModulesDataValid)="formModulesValid($event)"
    [arrangementSelected]="arrangementSelected">
</app-admissions-modules>

<span class="headline-1 mbs-5 text-primary-darker-title mt-5">
    {{ ('modules.admissions.admissions-provisions.template-title-practices' | exp:'':'Pedido de prestaciones')  }}
</span>
<div class="flex-row">
        <mat-icon class="mrs-1">info</mat-icon>
        <span class="text-caption">
            {{('modules.admissions.admissions-provisions.caption' | exp:'':'Las prestaciones cargadas en esta sección son adicionales al módulo y no forman parte de su contenido')}}
        </span>
    </div>

    <div>
        <app-theme-card themeScope="admissions">
            <form [formGroup]="practicesForm">
                <div formArrayName="practiceS">
                    <div *ngFor="let practice of practiceS.controls; let i=index">
                        <div [formGroupName]="i" class="flex-column">
                            <div class="flex-row flex-100 gap-1-5em align-start-center pxs-1">
                                <!-- Practice -->
                                <div class="flex-column flex-22">
                                    <span class="subtitle-3 text-primary-darker mbs-1">
                                        {{ 'modules.admissions.admissions-provisions.practice-form.subtitle' | exp:'':'Práctica' }} *
                                    </span>
                                    <app-select-searching-input
                                        [name]="this.PRACTICE" [nameSearching]="this.PRACTICE_SEARCHING"
                                        [form]="getPracticeSFormGroup(i)" [placeholder]="('modules.admissions.admissions-provisions.practice-form.placeholders.select-practice' | exp:'':'Seleccionar práctica')"
                                        [elements]="this.practicesFiltered" [calculateId]="this.calculateIdPractice"
                                        [calculateName]="this.calculateNamePractice"
                                        [placeholderNoValue]="('modules.admissions.admissions-provisions.practice-form.placeholders.no-value' | exp:'':'Sin resultados')"
                                        [placeholderSearching]="('modules.admissions.admissions-provisions.practice-form.placeholders.searching' | exp:'':'Buscar práctica...')">
                                    </app-select-searching-input>
                                </div>

                                <!-- Frecuency DAT -->
                                <div class="flex-column flex-25">
                                    <span class="subtitle-3 text-primary-darker mbs-1 flex-1">
                                        {{ 'modules.admissions.admissions-provisions.practice-form.frecuency.subtitle' | exp:'':'Frecuencia' }}
                                    </span>
                                    <div class="flex-row flex-100 gap-1-5em align-start-center">
                                        <app-number-input class="flex-25" [name]="this.AMOUNT" [minValue]="0"
                                            [form]="getPracticeSFormGroup(i)" [placeholder]="''">
                                        </app-number-input>

                                        <span class="flex-5" style="padding-bottom: 25px;">{{ 'modules.admissions.admissions-provisions.practice-form.frecuency.for' | exp:'':'por' }}</span>

                                        <!-- Frecuency PERIOD -->
                                        <app-select-input class="flex-50" [noOptionText]="('modules.admissions.admissions-provisions.practice-form.frecuency.placeholders.no-option' | exp:'':'Sin especificar')"
                                            [name]="this.UNIT" [elements]="this.provisionsFrequencyUnit"
                                            [form]="getPracticeSFormGroup(i)">
                                        </app-select-input>
                                    </div>
                                </div>

                                @if(shouldShowAllowedHours(i)){
                                <div class="flex-column flex-7">
                                    <span class="subtitle-3 text-primary-darker mbs-1"
                                        style="display: flex;width: max-content !important;">
                                        {{ 'modules.admissions.admissions-provisions.practice-form.frecuency.daily-hours' | exp:'':'Horas diarias' }}
                                    </span>
                                    <div class="flex-100">
                                        <app-number-input class="flex-100" [name]="this.ALLOWED_HOURS" [minValue]="0"
                                            [form]="getPracticeSFormGroup(i)" [placeholder]="''">
                                        </app-number-input>
                                    </div>
                                </div>
                                }
                                <!-- Radiobutton -->
                                <div class="flex-column flex-25 mbs-1">
                                    <mat-radio-group formControlName="radioButton"
                                        (change)="clickRadiobutton(i, $event)"
                                        class="flex-row flex-100 space-between-center"
                                        style="height: fit-content; margin-bottom: -8px;">
                                        <mat-radio-button value="duration" class="flex-50">
                                            <span class="subtitle-3 text-primary-darker mbs-1">
                                                {{ 'modules.admissions.admissions-provisions.practice-form.frecuency.duration' | exp:'':'Duración' }}
                                            </span>
                                        </mat-radio-button>

                                        <mat-radio-button value="date" class="subtitle-3 text-primary-darker flex-50">
                                            <span class="subtitle-3 text-primary-darker mbs-1">
                                                {{ 'modules.admissions.admissions-provisions.practice-form.frecuency.date' | exp:'':'Fecha' }}
                                            </span>
                                        </mat-radio-button>
                                    </mat-radio-group>
                                    <!-- Duración -->
                                    <ng-container
                                        *ngIf="this.practiceS['controls'][i]['controls'].radioButton.value === 'duration'">
                                        <div class="flex-row flex-100 flex-gap-small">
                                            <app-number-input [name]="this.DURATION_AMOUNT"
                                                [form]="getPracticeSFormGroup(i)" class="flex-50">
                                            </app-number-input>

                                            <app-select-input [icon]="'trending_up'" [noOptionText]="('modules.admissions.admissions-provisions.practice-form.placeholders.no-option' | exp:'':'Sin especificar')"
                                                [name]="this.DURATION_UNIT" [label]="''"
                                                [elements]="this.provisionsFrequencyUnit"
                                                [form]="getPracticeSFormGroup(i)" [defaultValue]="" class="flex-50">
                                            </app-select-input>
                                        </div>
                                    </ng-container>
                                    <!-- Fecha -->
                                    <ng-container
                                        *ngIf="this.practiceS['controls'][i]['controls'].radioButton.value === 'date'">
                                        <div class="flex-row flex-gap-small">
                                            <app-date-picker [name]="this.FROM_DATE" [form]="getPracticeSFormGroup(i)"
                                                [placeholder]="('modules.admissions.admissions-provisions.practice-form.frecuency.placeholders.from-date' | exp:'':'Desde')" class="flex-50">
                                            </app-date-picker>
                                            <app-date-picker [name]="this.TO_DATE" [form]="getPracticeSFormGroup(i)"
                                                [placeholder]="('modules.admissions.admissions-provisions.practice-form.frecuency.placeholders.to-date' | exp:'':'Hasta')" class="flex-50">
                                            </app-date-picker>
                                        </div>
                                    </ng-container>
                                </div>

                                <!-- Cant -->
                                <!-- // FIXME: hay una incidencia para verificar el uso de este campo, se oculta por el momento -->
                                <div class="flex-column flex-7" [hidden]="true">
                                    <span class="subtitle-3 text-primary-darker">
                                        {{ 'modules.admissions.admissions-provisions.practice-form.frecuency.amount' | exp:'':'Cantidad' }}
                                    </span>
                                    <app-number-input [name]="this.TOTAL_AMOUNT" [form]="getPracticeSFormGroup(i)"
                                        [minValue]="0" class="mt-4">
                                    </app-number-input>
                                </div>

                                <!-- ACTIONS -->
                                <div class="flex-row flex-7 start-none mbs-1 space-between-center flex-gap-medium ml-0">
                                    <!-- Remove practice -->
                                    <div class="flex-column flex-40">
                                        <button id="" [matTooltip]="('common.delete' | exp:'':'Borrar')" mat-icon-button [color]="'primary'"
                                            type="button" (click)="this.removePractice(i)">
                                            <mat-icon class="text-primary" outlined>delete_outline</mat-icon>
                                        </button>
                                    </div>
                                    <!-- Add practice -->
                                    <div class="flex-column flex-40">
                                        <button id="" [matTooltip]="('common.add' | exp:'':'Agregar')" mat-icon-button [color]="'primary'"
                                            type="button" *ngIf="true" (click)="this.addPractice()"
                                            [disabled]="btn_addPractice_disabled"
                                            [hidden]="(i+1)==practiceS['controls'].length ? false : true">
                                            <mat-icon>add_circle_outline</mat-icon>
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </app-theme-card>
    </div>
</div>
